'use client';
import React from 'react';
import { Phone, MessageSquare, Send } from 'lucide-react';
import { trackEvent } from '@/components/common/Analytics';

/**
 * StickyMobileCTA - High-visibility conversion bar for mobile viewports.
 * Provides instant access to WhatsApp, Call, and Quote actions.
 */
const StickyMobileCTA = () => {
    const handleAction = (label) => {
        trackEvent('click', 'MobileStickyCTA', label);
    };

    return (
        <div
            className="hidden fixed bottom-0 left-0 right-0 z-[100] md:hidden bg-white/90 backdrop-blur-xl border-t border-slate-200 px-4 pt-3 flex items-center justify-between gap-3 shadow-[0_-10px_30px_rgba(0,0,0,0.07)]"
            style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
        >
            {/* WhatsApp CTA */}
            <a 
                href="https://wa.me/919810141671" 
                onClick={() => handleAction('WhatsApp')}
                className="no-tap-enforce flex-1 flex items-center justify-center gap-2 py-3 bg-[#25D366] text-white rounded-2xl font-bold text-sm shadow-lg shadow-green-500/20 active:scale-95 transition-all min-h-[44px]"
                aria-label="Contact on WhatsApp"
            >
                <MessageSquare className="w-4 h-4 fill-current" />
                <span>WhatsApp</span>
            </a>

            {/* Request Quote Primary CTA */}
            <a 
                href="/quote" 
                onClick={() => handleAction('RequestQuote')}
                className="no-tap-enforce flex-[1.5] flex items-center justify-center gap-2 py-3 bg-[#0a1f33] text-white rounded-2xl font-bold text-sm shadow-lg shadow-slate-900/10 active:scale-95 transition-all min-h-[44px]"
            >
                <Send className="w-4 h-4" />
                <span>Request Quote</span>
            </a>

            {/* Quick Call */}
            <a 
                href="tel:+919810141671" 
                onClick={() => handleAction('PhoneCall')}
                className="no-tap-enforce w-12 min-h-[44px] flex items-center justify-center bg-blue-50 text-blue-600 rounded-2xl border border-blue-100 active:scale-95 transition-all"
                aria-label="Call Now"
            >
                <Phone className="w-5 h-5" />
            </a>
        </div>
    );
};

export default StickyMobileCTA;
